module.exports = {
        srcSet: "/_next/static/images/video-delivery-640.ced218f8.webp"+" 640w"+","+"/_next/static/images/video-delivery-828.c4cb3a68.webp"+" 828w"+","+"/_next/static/images/video-delivery-958.97c02694.webp"+" 958w",
        images: [{path: "/_next/static/images/video-delivery-640.ced218f8.webp",width: 640,height: 749},{path: "/_next/static/images/video-delivery-828.c4cb3a68.webp",width: 828,height: 969},{path: "/_next/static/images/video-delivery-958.97c02694.webp",width: 958,height: 1121}],
        src: "/_next/static/images/video-delivery-958.97c02694.webp",
        toString: function(){return "/_next/static/images/video-delivery-958.97c02694.webp"},
        
        width: 958,
        height: 1121
      }